import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { GreyhoundAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/GreyhoundAndTrainerDetails';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';
import { withConfig } from 'src/withConfig';

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 12px;
    justify-content: start;
    min-width: 120px;
    overflow: hidden;
    padding: 8px 12px;
`;

export const RaceCardTrap = styled(Trap, { label: 'RaceCardTrap' })`
    flex: 0 0 32px;
    padding: 4px;
    width: 32px;
`;

export const GreyhoundAndTrainerDetailsBox = withConfig(theme => styled(GreyhoundAndTrainerDetails, { label: 'GreyhoundAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);

interface UnnamedFavouritePropsType {
    isAntePost: boolean;
}

export const UnnamedFavouriteLabel = styled('div', { label: 'UnnamedFavouriteLabel' })<UnnamedFavouritePropsType>`
    align-items: center;
    border-right: none;
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-start;
    padding-left: ${({ isAntePost }): string => isAntePost ? '8px' : '16px'};
`;

interface PriceHistoryCellPropsType {
    isRaceInProgress?: boolean;
    variant: DefaultComponentVariantType | null;
}

export const PriceHistoryCell = withConfig(theme => styled('span', { label: 'PriceHistoryCell' })<PriceHistoryCellPropsType>`
    align-items: center;
    border-color: ${theme.star.raceSummary.borderColor};
    border-style: solid;
    border-width: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '0' : '0 1px'};
    display: flex;
    flex: 0 0 64px;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    padding: 8px;
    text-align: center;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 96px;
    }
`);
